import { render, staticRenderFns } from "./office-manager.vue?vue&type=template&id=4f3c6c3a"
import script from "./office-manager.vue?vue&type=script&lang=js"
export * from "./office-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports